import React, { Component, ErrorInfo } from 'react';
import { GeneralError } from './components/pages/GeneralError';
import { telemetry } from './telemetry';

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    telemetry.captureError(error, { errorInfo });
    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) {
      return <GeneralError />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
